export const Link = {
  baseStyle: {
    position: "relative",
    fontWeight: "semibold",
    textDecoration: "none",
  },
};
